// extracted by mini-css-extract-plugin
module.exports = {"moreActions":"ActionBtn_moreActions__3390H","icon":"ActionBtn_icon__36drw","optionsList":"ActionBtn_optionsList__YMJjc"};